import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiGateway } from 'api/api-gateway';

@Injectable({
  providedIn: 'root'
})
export class UnregisteredNewService {

constructor(
  private apiGateway: ApiGateway,
  private http: HttpClient,
  ) { }


savePatient(patient){
  return new Promise((resolve, reject) => {
    this.apiGateway.post("datasnap/rest/TPatientController/paciente/", patient).
    subscribe({
      next: (res: HttpResponse<any[]>) => {res.body ? resolve(res.body) : resolve(res)},
      error(error)  {reject(error)}
    })
  })
}


getCep(cep): Promise<any> {
  return new Promise((resolve, reject) => {
    this.http
      .get(`https://viacep.com.br/ws/${cep}/json`)
      .subscribe({
        next: (res: HttpResponse<any[]>) => { res.body ? resolve(res.body) : resolve(res) },
        error(error) { reject(error) }
      });
  });
}


getSexoList(): Promise<any> {
  return new Promise((resolve, reject) => {
    this.apiGateway
      .get(`datasnap/rest/TDomainController/sexo`)
      .subscribe({
        next: (res: HttpResponse<any[]>) => { res.body ? resolve(res.body) : resolve(res) },
        error(error) { reject(error) }
      });
  });
}

getRaceList(): Promise<any> {
  return new Promise((resolve, reject) => {
    this.apiGateway
      .get(`datasnap/rest/TDomainController/raca`)
      .subscribe({
        next: (res: HttpResponse<any[]>) => { res.body ? resolve(res.body) : resolve(res) },
        error(error) { reject(error) }
      });
  });
}

getMaritalStatusList(): Promise<any> {
  return new Promise((resolve, reject) => {
    this.apiGateway
      .get(`datasnap/rest/TDomainController/estadocivil`)
      .subscribe({
        next: (res: HttpResponse<any[]>) => { res.body ? resolve(res.body) : resolve(res) },
        error(error) { reject(error) }
      });
  });
}


getnationalityList(): Promise<any> {
  return new Promise((resolve, reject) => {
    this.apiGateway
      .get(`datasnap/rest/TDomainController/nacionalidade`)
      .subscribe({
        next: (res: HttpResponse<any[]>) => { res.body ? resolve(res.body) : resolve(res) },
        error(error) { reject(error) }
      });
  });
}


getPatientById(idPatient): Promise<any> {
  return new Promise((resolve, reject) => {
    this.apiGateway
      .get(`datasnap/rest/TPatientController/paciente/${idPatient}`)
      .subscribe({
        next: (res: HttpResponse<any[]>) => { res.body ? resolve(res.body) : resolve(res) },
        error(error) { reject(error) }
      });
  });
}

}

